import axiosInstance from './AxiosInstance';
import { getApiUrl } from '../utils/ApiUtils';

export async function submitFeedback(payload) {
    const url = getApiUrl('feedback');
    const response = await axiosInstance.post(url, payload);
    return response.data;
}
